import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { router } from "./router";
import { initEnvTheme } from "./utils/env-theme";
import { ENV } from "./config/env";
import "./index.css";
import { registerServiceWorkerAutoReload } from "@shared-ui/utils/registerServiceWorkerAutoReload";

// Initialize environment theme colors before React renders
initEnvTheme(ENV.ENV);

// PRODUCT_DEV-471: リリース後の自動反映 (3プロダクト共通)
registerServiceWorkerAutoReload();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
